<div class="search-container">
  <app-element-select displayLabel='Select Person'
                      [defaultValue]="defaultPersonSelected"
                      [options]="personsNameValueDTO"
                      [emitNameValueDTO]="true"
                      (selectionChanged)="onSelectionChange($event)">
  </app-element-select>
  <mat-form-field class='filter-form-field'>
    <mat-label>Search by Subject</mat-label>
    <input matInput type='text' [formControl]="subjectLineSearchControl">
  </mat-form-field>
</div>


<ng-container *ngIf="isDataExist; else emptyEmailDataTable">
  <greydom-email-table
    [emailDataSource]="emailDataSource"
    [emailTableControl]="emailTableControl"
    [dateTimeFormat]="dateTimeFormat"
    [emailExpandedRow]="emailExpandedRow"
    [emailOverrideFormControl]="emailOverrideFormControl"
    (sortData)="sortData($event)"
    (pageChanged)="pageChanged($event)"
    (rowClicked)="onClickRow($event.event, $event.row)"
    (sendEmailConfirmed)="onClickSendEmailConfirmed($event.event, $event.row)"
    (toggleIcons)="onClickToggleIcons($event.event, $event.row)"
    (editAddress)="onClickEditAddress($event.event, $event.row)"
    (cancelEditAddress)="onClickCancelEditAddress($event.event, $event.row)"
    (saveAddress)="onClickSaveAddress($event.event, $event.row)"
    (duplicate)="OnClickDuplicate($event.duplicate, $event.row)"
    (generatePdfReport)="onClickGeneratePdfReport($event.event, $event.row)"
    (clickResetEmailConfirmed)="onClickResetEmailConfirmed($event.event, $event.row)"
    (clickToggleResetEmailIcons)="onClickToggleResetEmailIcons($event.event, $event.row)">
  </greydom-email-table>
</ng-container>

<ng-template #emptyEmailDataTable>
  <div class="text-center">
    <label class="column-label claim-column-label">No email data</label>
  </div>
</ng-template>
